import { CHANGE_ACTIVE, CHANGE_NAME, CHANGE_NUMBER, CHANGE_STATUS, FLOW_DELETE_LOCAL_SUCCEEDED, FLOW_FETCH, FLOW_UPDATE, FLUSH, UNSAVED_CHANGES, } from '../constants/actionTypes';
import { initBuild } from './nodeActions';
export function setStatus(status) {
    return (dispatch) => {
        if (!status) {
            console.error('setStatus no isLoading params given.');
            return;
        }
        dispatch({ type: CHANGE_STATUS, status });
    };
}
export function changeName(name) {
    return (dispatch) => {
        dispatch({ type: CHANGE_NAME, name });
    };
}
export function changeNumber(phoneNumber) {
    return (dispatch) => {
        dispatch({ type: CHANGE_NUMBER, number: phoneNumber });
    };
}
export function flushFlow() {
    return (dispatch) => {
        dispatch({ type: FLUSH });
    };
}
export function removeLocalFlow() {
    try {
        localStorage.removeItem('unsaved_flow');
        return { type: FLOW_DELETE_LOCAL_SUCCEEDED };
    }
    catch (e) {
        console.error(e);
        return undefined;
    }
}
export function changeActive(isActive = null) {
    return (dispatch) => {
        if (isActive === null) {
            console.error('changeActive no isActive boolean params given.');
            dispatch(setStatus('complete'));
            return;
        }
        dispatch({ type: CHANGE_ACTIVE, isActive: isActive });
    };
}
export function unSavedChanged(hasChanged = null) {
    return (dispatch) => {
        if (hasChanged === null) {
            console.error('unSavedChanged no hasChanged boolean params given.');
            dispatch(setStatus('complete'));
            return;
        }
        dispatch({ type: UNSAVED_CHANGES, hasChanged });
    };
}
export function updateFlow(flow = null, initialActions) {
    return (dispatch) => {
        if (flow === null) {
            console.error('updateFlow no flow params given.');
            dispatch(setStatus('complete'));
            return;
        }
        dispatch(setStatus('loading'));
        dispatch({ type: FLOW_UPDATE, payload: { flow, initialActions } });
    };
}
export function fetchFlow(id) {
    return (dispatch) => {
        if (!id) {
            // We need to dispatch the init action.
            dispatch(setStatus('complete'));
            dispatch(initBuild());
        }
        else {
            // We dispatch the action. The callFlow Saga is watching for FLOW_FETCH actions.
            dispatch({ type: FLOW_FETCH, payload: { id } });
        }
    };
}
